import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText'
import { useTranslation } from 'react-i18next'
import { SelectController } from 'settle-ui/form/SelectController/SelectController'
import { useProductFormContext } from '../../../../hooks/useProductForm/useProductForm'
import { BusinessTypeEnum } from 'gql/types'

export const BusinessTypeSelector = () => {
  const { t } = useTranslation()
  const form = useProductFormContext()

  const businessTypeOptions = [
    {
      title: t('productPageForm::businessTypeSelector::accounting::title'),
      description: t('productPageForm::businessTypeSelector::accounting::description'),
      value: BusinessTypeEnum.ACCOUNTING_PARTNER,
    },
    {
      title: t('productPageForm::businessTypeSelector::business::title'),
      description: t('productPageForm::businessTypeSelector::business::description'),
      value: BusinessTypeEnum.PAYER,
    },
  ]

  return (
    <SelectController
      required={true}
      fullWidth={true}
      name="businessType"
      data-testid="business-type-select"
      control={form.control}
      label={t('productPageForm::businessTypeSelector::label')}
      rules={{ required: { value: true, message: t('validation::cantBeEmpty') } }}
      renderValue={(value) => businessTypeOptions.find((option) => option.value === value)?.title}
    >
      {businessTypeOptions.map(({ value, title, description }) => (
        <MenuItem key={value} value={value}>
          <ListItemText primary={title} secondary={description} />
        </MenuItem>
      ))}
    </SelectController>
  )
}
